document.querySelectorAll("details.faq").forEach(function (item) {
  const indicator = item.querySelector(".faq-icon i");

  const toggleIndicator = () => {
    if (item.open) {
      indicator.classList.remove("fa-plus");
      indicator.classList.add("fa-minus");
    } else {
      indicator.classList.remove("fa-minus");
      indicator.classList.add("fa-plus");
    }
  };

  toggleIndicator();

  item.addEventListener("toggle", toggleIndicator);
});
